exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{\r\n  font-family: Arial, \"Helvetica Neue\", Helvetica, sans-serif;\r\n}\r\nh6{\r\n  color: #007b85;\r\n  font-size:18px;\r\n  font-weight: bolder;\r\n\r\n}\r\n.panel-default{\r\n  box-shadow: 1px 1px 1px 1px #C0C0C0;\r\n}\r\n.breadcrumb{\r\n  margin-top:10px;\r\n}\r\nol.breadcrumb li+li:before {\r\n    padding: 8px;\r\n    color: black;\r\n    content: \"/\\A0\";\r\n}\r\ninput[type=radio]{\r\n  opacity:0px;\r\n}\r\n.search-form{\r\n  border-radius: 30px 0px 0px 30px;\r\n}\r\n\r\n.autocomplete-content > li {\r\n\tborder-bottom: 1px solid #C0C0C0;\r\n}\r\n.autocomplete-content {\r\n\tmargin-top: -15px;\r\n\tmax-height: 430px\r\n}\r\n.autocomplete-content > li:hover {\r\n\tbackground-color: #ececec;\r\n}\r\n#searchInput {\r\n\twidth: 93% !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/customer/customer.component.css
// module id = 455
// module chunks = 1